/* eslint-disable standard/no-callback-literal */
const utils = {
  previewPdf (e, fileId, _data) {
    if (_data.previewPdf) return;
    const vDomVue = e.currentTarget.__vue__;
    vDomVue.$set(_data, 'previewPdf', true);
    this.initDownloadPdf(vDomVue, fileId)
      .then((rsp) => {
        const filePath = rsp.data.data;
        vDomVue.$axios.get(`${vDomVue.$config.fileApi.download}/${filePath}`, { responseType: 'blob' })
          .then((res) => {
            // const fileStream = res.data;
            // // 读取文件名
            // const fileName = decodeURIComponent(escape(res.headers['content-disposition'].split('=')[1]));
            // vDomVue.$HMUtil.downloadStreamFile(fileStream, fileName);
            const blob = new Blob([res.data], { type: 'application/pdf' });
            const path = URL.createObjectURL(blob);
            _data.previewPdf = false;
            setTimeout(() => {
              window.open(path);
            });
          })
          .catch((err) => {
            console.error('下载文件失败！', err);
            _data.previewPdf = false;
          });
      })
      .catch((err) => {
        console.error('初始化下载文件失败！', err);
        _data.previewPdf = false;
      });
  },
  /**
   * @description: 初始化下载
   * @param {*} fileId
   * @return {*}
   */
  initDownloadPdf (vDomVue, fileId) {
    return vDomVue.$axios.get(`${vDomVue.$config.fileApi.initDownload}/${fileId}`);
  }
};
export default utils;
